<script>
  import CausesOfDeathMini from "./CausesOfDeathMini.svelte";
  import Thermometer from "./Thermometer.svelte";
  import MapLegend from "./MapLegend.svelte";

  import { thermometer_is_showing } from "./../content/data.json";

  import { debounce, throttle } from "./../utils.js";
  import { timer as d3Timer } from "d3-timer";

  const numberOfYears = 79;

  let activeYearIndex = 0;
  let currentTime = 0;
  let duration = 100;
  let videoElement;

  $: progress = currentTime / duration;
  $: activeYearIndex = Math.max(
    0,
    Math.min(numberOfYears, Math.round(numberOfYears * progress))
  );

  let hasSetRate = false;
  const onTimeUpdate = e => {
    if (!videoElement) return;

    if (!hasSetRate) {
      videoElement.playbackRate = 0.3;
      hasSetRate = true;
    }
    duration = videoElement.duration;

    if (progress >= 0.98) {
      videoElement.pause();
      activeYearIndex = numberOfYears;
      setTimeout(() => {
        if (!videoElement) return;
        videoElement.play();
      }, 6000);
    }
  };
  $: currentTime, onTimeUpdate();
</script>

<div class="c">
  <div class="controls">
    <div class="slider">
      <h6 class="year-label">Year</h6>
      <div
        class="year"
        style="{`top: ${(activeYearIndex * 100) / numberOfYears}%`}">
        {activeYearIndex + 2020}
      </div>
      <!-- <input
          type="range"
          bind:value="{activeYearIndex}"
          min="0"
          max="{numberOfYears}" /> -->
    </div>
    <MapLegend {activeYearIndex} />
    <div class="bar-chart">
      <CausesOfDeathMini year="{activeYearIndex + 2020}" />
    </div>
    {#if thermometer_is_showing}
      <div class="thermometer">
        <Thermometer year="{activeYearIndex + 2020}" />
      </div>
    {/if}
  </div>

  <div class="video">
    <video
      bind:this="{videoElement}"
      loop
      autoplay
      muted
      defaultMuted
      playsinline
      bind:currentTime
      playbackRate="{0.3}">
      <source src="/assets/map.mp4" type="video/mp4" />
      Sorry, your browser doesn't support embedded videos.
    </video>
  </div>
</div>

<style>
  .c {
    position: relative;
    max-width: 1500px;
    margin: 0 auto;
    display: flex;
    align-items: center;
  }
  .year-label {
    font-size: 0.8rem;
    line-height: 1.3em;
    margin-bottom: 0;
    padding-bottom: 0.3em;
  }
  .year {
    margin-bottom: 0.3em;
    font-size: 2em;
    font-weight: 900;
    font-feature-settings: "tnum" 1;
  }
  .controls {
    z-index: 100;
    text-align: left;
    pointer-events: none;
    width: 10em;
    margin-right: -2em;
  }
  .bar-chart {
    margin-top: 3.6em;
    width: 100%;
  }
  .thermometer {
    margin-top: 3.6em;
    width: 100%;
  }
  .slider {
    width: 100%;
    pointer-events: all;
  }
  .video {
    width: 100%;
    /* padding-left: 10em; */
  }
  video {
    width: 100%;
  }
</style>
